import React from 'react'
import ProdsNServsComp from '../../ProdsNServsComp'
import { Link } from 'react-router-dom'
import {PSObjTwo } from './Data'
function Products() {
  return (
    <>
    
    <ProdsNServsComp {...PSObjTwo} />
   
    </>
  )
}

export default Products